import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, type SxProps, type Theme } from "@mui/material";
import ExpandIcon from "../../assets/common/Open-task-icon.svg";
import CollapseIcon from "../../assets/common/Close-task-icon.svg";
import styles from "./Meetings.Style";

interface InteractionAccordionProps {
  title: string;
  count: number | undefined;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  pinToTop?: boolean;
  children: React.ReactNode;
}

const InteractionAccordion = ({
  title,
  count,
  expanded,
  onExpandedChange,
  pinToTop = false,
  children,
}: InteractionAccordionProps) => (
  <Accordion
    disableGutters
    elevation={0}
    expanded={expanded}
    onChange={(_event, isExpanded) => onExpandedChange(isExpanded)}
    sx={
      (pinToTop
        ? [styles["interaction-accordion"], styles["interaction-accordion--pinned"]]
        : styles["interaction-accordion"]) as SxProps<Theme>
    }
  >
    <AccordionSummary sx={styles["interaction-accordion__summary"]}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Box
          component="img"
          src={expanded ? CollapseIcon : ExpandIcon}
          alt=""
          sx={
            expanded
              ? styles["interaction-accordion__collapseImg"]
              : styles["interaction-accordion__expandImg"]
          }
        />
        <Typography sx={styles["interaction-accordion__title"]}>
          {title}
          {count == null ? "" : (
            <Box component="span" sx={styles["interaction-accordion__count"]}>
              {` [${count}]`}
            </Box>
          )}
        </Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails sx={styles["interaction-accordion__details"]}>
      {expanded ? children : null}
    </AccordionDetails>
  </Accordion>
);

export default InteractionAccordion;
